import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { getUserList } from "../../services/user.service";
import { MdContentCopy } from "react-icons/md";
import { getUpcomingCourseInterests } from "services/admin.service";

function UpcomingInterestedUsers(props) {
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const [copy, setCopy] = useState(false);
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getUpcomingCourseInterests();
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error
          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  function CustomRow(props) {
    const { row, index, skipValue } = props;

    return (
      <>
        <TableRow key={row._id}>
          <TableCell>{index + 1 + skipValue}</TableCell>
          <TableCell>
            <Link
              to={"/dashboard/mentees/" + row.user._id}
              className="hover:underline"
            >
              {row.user.firstname
                ? row.user.firstname + " " + row.user.lastname
                : "Not Set"}
            </Link>
          </TableCell>
          <TableCell>
            <Link
              to={"/dashboard/courses/view/" + row.course._id}
              className="hover:underline"
            >
              {row.course ? row.course.name : "Not Set"}
            </Link>
          </TableCell>
          <TableCell>
            {moment(row.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div>
      <Box style={{ width: "100%" }}>
        <TableContainer>
          <div className="flex justify-end gap-5">
            {/* <Button
              variant="outlined"
              className="my-8"
              onClick={(e) => {
                navigate("/dashboard/mentor/edit");
              }}
            >
              Create Mentor
            </Button> */}
          </div>
          <Table size="small">
            <TableHead className="">
              <TableRow className=""></TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Fullname</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Course</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row, index) => {
                    return (
                      <CustomRow
                        row={row}
                        key={index}
                        index={index}
                        skipValue={0}
                      />
                    );
                  })
                : null}
            </TableBody>
          </Table>
          {/* <div style={{ marginTop: '20px', textAlign: 'center' }} hidden={survey.length != 0}>
                No data with given filters
            </div> */}
        </TableContainer>
      </Box>
    </div>
  );
}

export default UpcomingInterestedUsers;
